import { observer } from 'mobx-react';
import { memo } from 'react';
import { ItemsInventoryHeader } from '../../containers/ItemsInventoryHeader/ItemsInventoryHeader';
import { MealCombosList } from './containers/MealCombosList/MealCombosList';
import { itemsInventoryMealStore } from './store/itemsInventoryMealStore';
import { POS_SYSTEM_ID } from 'src/constants/integrations';
import theme from 'src/constants/styles';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import FullScreenMessage from 'src/view/components/FullScreenMessage/FullScreenMessage';
import { Table } from 'src/view/components/Table/Table';

const MealCombosScreen: React.FC = memo(
  observer((): JSX.Element => {
    return (
      <Table>
        {appStore.settings?.pos_system_id === POS_SYSTEM_ID.MARN ? (
          <FullScreenMessage message={localeStore.t('pos_on_meal_combo')} justify="start" className="px-8 mt-20" iconColor={theme.colors.gray2} />
        ) : (
          <>
            <ItemsInventoryHeader
              loading={itemsInventoryMealStore.isLoading}
              filters={itemsInventoryMealStore.filters}
              totalItems={itemsInventoryMealStore.pagination.total}
              setFilters={itemsInventoryMealStore.setFilters}
            />
            <MealCombosList />
          </>
        )}
      </Table>
    );
  })
);

export default MealCombosScreen;
